const handleVideos = (videos) => {
    if (videos) {
        videos.forEach(item => {
            const videoPlay = item.nextElementSibling?.classList.contains('video-play') ? item.nextElementSibling : false;
            item.addEventListener('click', () => {
                if (item.paused) {
                    item.play();
                } else {
                    item.pause();
                }
            });
            if (videoPlay) {
                item.addEventListener('ended', () => {
                    videoPlay.classList.remove('d-none');
                }, false);
                videoPlay.addEventListener('click', (e) => {
                    const itemSource = item.querySelector('source');
                    if (itemSource.dataset.src) {
                        // itemSource.setAttribute('src', itemSource.dataset.src);
                        item.load();
                        let playPromise = item.play();
                        if (playPromise !== undefined) {
                            playPromise.then(function () {
                                item.play();
                            }).catch(function (error) {
                                console.log(error);
                            });
                        }
                    } else {
                        item.play();
                    }
                    videoPlay.classList.add('d-none');
                },false);
            }
        });
    }
}
export default handleVideos;
